import {jwtDecode} from 'jwt-decode';  // A jwt-decode csomag használata a token dekódolásához
import { useNavigate } from 'react-router-dom';
import { useFormSave } from '../context/FormSaveContext';
import { useEffect, useRef } from 'react';
import { clearAuthState, getAuthToken } from '../utils/authStorage';

const checkTokenExpiry = (token, loginTime) => {
    if (!token) return false;

    try {
        // Check if token expired after 2 hours (7200 seconds)
        const currentTime = Date.now() / 1000;  // Másodpercekben
        const timeElapsed = currentTime - loginTime;
        
        if (timeElapsed > 7200) {  // 2 hours = 7200 seconds
            console.log('Token expired (2 hours elapsed)');
            return true;
        }

        // Also check JWT expiration
        try {
            const decodedToken = jwtDecode(token);
            if (decodedToken.exp < currentTime) {
                console.log('Token expired based on JWT expiration');
                return true;
            }
        } catch (decodeError) {
            console.error('Error decoding token:', decodeError);
        }
        
        return false;
    } catch (error) {
        console.error('Invalid token', error);
        return false;
    }
};

export const useTokenExpiryCheck = () => {
    const navigate = useNavigate();
    const { triggerSave } = useFormSave();
    const intervalRef = useRef(null);
    const isLoggingOutRef = useRef(false);
    const loginTimeRef = useRef(Date.now() / 1000);  // Store login time for testing

    useEffect(() => {
        // Reset login time when component mounts
        loginTimeRef.current = Date.now() / 1000;
        console.log('Token expiry check started - will expire in 2 hours');

        intervalRef.current = setInterval(async () => {
            const token = getAuthToken();  // Az access token tárolása (consistent key)
            const isExpired = checkTokenExpiry(token, loginTimeRef.current);

            if (isExpired && !isLoggingOutRef.current) {
                isLoggingOutRef.current = true;
                clearInterval(intervalRef.current);
                
                console.log('Token expired - auto-saving and logging out...');
                
                // Save the current form before logging out
                await triggerSave();
                
                clearAuthState();  // Token eltávolítása
                localStorage.removeItem('refresh_token');  // Refresh token is eltávolítása
                navigate('/login');  // Átirányítás a login oldalra
            }
        }, 1000);  // másodpercenként ellenőriz

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [navigate, triggerSave]);
};
